module.exports = __webpack_public_path__ + "static/media/news1.ad1acabf.png";